import React, { Component, useEffect, useState } from "react";
import config from "../config.json";
// Removed LocationDetails and BrowserDetails modal imports since details are rendered inline in tabs
import Pagination from "../comman/pagination";
import { paginate, calculateIndex } from "../utlis/paginate";
import LogsTable from "./LogsTable";
import PageSizeOptions from "./PageSizeOptions";
import InfoHeader from "../comman/infoHeader";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getLoginTrails, loadLoginTrails, loadLoginTrailsByFilter, getLoginTrailsLoading } from "../app/store/reports";
import { getAlert } from "../services/appAlerts";

const MonitoringLogs = () => {

  const route = [{ url: "", name: "Security" }];

  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [rowsCount, setRowsCount] = useState(0);
  const [id, setId] = useState("");
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [country, setCountry] = useState("");
  const [dataType, setDataType] = useState("");
  const [selectedKey, setSelectedKey] = useState("home");
  const [selectedLogId, setSelectedLogId] = useState(0);
  const [selectedLogObj, setSelectedLogObj] = useState(null);

  const handleTabSelect = (tab) => {
    setSelectedKey(tab);
  };

  const handleResetSelection = () => {
    setSelectedLogId(0);
    setSelectedLogObj(null);
  };

  const handleSelectLog = (item) => {
    if (selectedLogId === item.id) {
      handleResetSelection();
    } else {
      setSelectedLogId(item.id);
      setSelectedLogObj(item);
    }
  };

  const loginTrailsSelector = useSelector(getLoginTrails)
  const isLoading = useSelector(getLoginTrailsLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentPageTitle("Monitoring Logs"));
    dispatch(setCurrentRoute(route));
  }, []);

  useEffect(() => {
    dispatch(loadLoginTrails(pageSize, currentPage));
  }, [])

  useEffect(() => {
    if (loginTrailsSelector?.isSuccess) {
      setLogs(loginTrailsSelector.data);
      setRowsCount(loginTrailsSelector.totalRecords);
    }
  }, [loginTrailsSelector])

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    handleResetSelection();
    if (dataType !== "filter")
      dispatch(loadLoginTrails(pageSize, page));
    else
      handleFilter(pageSize, page);
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    handleResetSelection();
    if (dataType !== "filter")
      dispatch(loadLoginTrails(currentTarget.value, currentPage));
    else
      handleFilter(currentTarget.value, currentPage);
  };

  const handleFilterCancel = () => {
    setPageSize(5);
    setCurrentPage(1);
    setStartIndex(0);
    setUserId("");
    setUserName("");
    setIpAddress("");
    setCountry("");
    setDataType("");
    handleResetSelection();
    dispatch(loadLoginTrails(5, 1));
  };

  const handleRefresh = () => {
    handleResetSelection();
    if (dataType === "filter") handleFilter(pageSize, currentPage);
    else dispatch(loadLoginTrails(pageSize, currentPage));
  };

  const handleFilter = (pSize, pIndex) => {
    if (!userId.trim() && !userName.trim() && !ipAddress.trim() && !country.trim()) return;
    setPageSize(pSize);
    setCurrentPage(pIndex);
    setDataType("filter");

    const frmBody = new FormData();
    frmBody.append("userId", userId);
    frmBody.append("userName", userName);
    frmBody.append("ip", ipAddress);
    frmBody.append("country", country);
    frmBody.append("pageSize", pSize);
    frmBody.append("pageIndex", pIndex);
    dispatch(loadLoginTrailsByFilter(frmBody));
  };

  return (
    <React.Fragment>
      <style>{`
        /* WorkflowUser matching styles for MonitoringLogs */
        .ml-container,
        .ml-container input,
        .ml-container select,
        .ml-container button,
        .ml-container textarea,
        .wf-table-scroll,
        .wf-table-scroll table,
        .wf-table-scroll th,
        .wf-table-scroll td {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .ml-container {
          color: #1e293b;
        }

        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 18px !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 14px 20px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          background: linear-gradient(90deg, #fafbfd 0%, #ffffff 100%) !important;
          border-radius: 18px 18px 0 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .wf-stats-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(100, 116, 139, 0.07);
          border: 1px solid rgba(100, 116, 139, 0.18);
          color: #1e293b;
          border-radius: 0;
          padding: 5px 12px;
          font-size: 14px;
          font-weight: 500 !important;
          letter-spacing: 0.2px;
        }

        .wf-stats-chip i {
          font-size: 14px;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: 32px !important;
          height: auto !important;
          box-sizing: border-box !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #cbd5e1 !important;
          box-shadow: none !important;
        }

        @keyframes searchSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .search-panel-collapse {
          background: linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.95) 100%) !important;
          backdrop-filter: blur(16px) !important;
          -webkit-backdrop-filter: blur(16px) !important;
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 16px !important;
          padding: 0 !important;
          box-shadow: none !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }

        .search-panel-collapse :not(i) {
          font-weight: inherit !important;
        }
        .search-panel-collapse input::placeholder,
        .search-panel-collapse textarea::placeholder {
          font-weight: 400 !important;
        }
        .search-panel-collapse [class*="-placeholder"] {
          font-weight: 400 !important;
        }

        .sp-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.8);
          background: linear-gradient(90deg, #f8fafc 0%, #ffffff 100%);
        }

        .sp-header-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: 0.1px;
        }

        .sp-header-title i {
          color: #64748b;
          font-size: 14px;
        }

        .sp-body {
          padding: 18px 20px 14px;
        }

        .sp-footer {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          padding: 12px 20px !important;
          border-top: 1px solid rgba(226, 232, 240, 0.7) !important;
          background: linear-gradient(90deg, #ffffff 0%, #f8fafc 100%) !important;
        }

        .wf-control-label {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.08em !important;
          margin-bottom: 7px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-control-label i {
          color: #94a3b8;
          font-size: 12px;
        }

        .wf-input-wrap {
          position: relative;
        }

        .wf-input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
          pointer-events: none;
          transition: color 0.2s ease;
          z-index: 1;
        }

        .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb;
        }

        .wf-input {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          padding: 9px 14px !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          height: auto !important;
          width: 100% !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          font-weight: 400 !important;
        }

        .wf-filter-input-no-icon .wf-input {
          padding-left: 14px !important;
        }

        .wf-input::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-input:hover {
          border-color: #94a3b8 !important;
          box-shadow: none !important;
        }

        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #ffffff !important;
        }

        /* Search Actions */
        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          min-height: 32px !important;
          height: auto !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: none !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          font-weight: 500 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px -1px rgba(37, 99, 235, 0.25) !important;
        }

        .btn-action-search:disabled,
        .btn-action-search[disabled],
        .btn-action-search.btn-primary-search:disabled {
          background: #dbe2ea !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          opacity: 0.85 !important;
          transform: none !important;
          box-shadow: none !important;
        }

        .btn-action-search.btn-danger-search {
          background: rgba(239, 68, 68, 0.06) !important;
          color: #dc2626 !important;
          border: 1px solid rgba(239, 68, 68, 0.18) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: rgba(239, 68, 68, 0.12) !important;
          color: #b91c1c !important;
          border-color: rgba(239, 68, 68, 0.28) !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 8px -2px rgba(239, 68, 68, 0.12) !important;
        }

        /* Modern Table Style */
        .wf-table-scroll {
          overflow: auto !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          background: #ffffff;
        }

        .wf-table-scroll::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-table-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        .wf-table-scroll table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 2px !important;
          margin-bottom: 0 !important;
          border: none !important;
        }

        .wf-thead {
          background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 13px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          white-space: nowrap !important;
        }

        .wf-table-scroll tbody tr,
        .wf-table-scroll table tbody tr {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
          background: #ffffff !important;
        }

        .wf-table-scroll table.table-striped tbody tr:nth-of-type(odd),
        .wf-table-scroll tbody tr:nth-of-type(odd) {
          background: #ffffff !important;
        }

        .wf-table-scroll tbody tr:hover {
          background: linear-gradient(90deg, #f5f5f5 0%, #fafafa 100%) !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }

        .wf-table-scroll tbody tr:hover td {
          color: #1e293b !important;
        }

        .wf-table-scroll tbody tr.selected-row {
          background: linear-gradient(90deg, #f5f5f5 0%, #fafafa 100%) !important;
          box-shadow: inset 4px 0 0 0 #171717 !important;
        }

        .wf-table-scroll tbody tr td,
        .wf-table-scroll table tbody tr td {
          padding: 13px 16px !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: middle !important;
          transition: color 0.15s ease !important;
        }

        .wf-table-scroll tbody tr.selected-row td {
          color: #1e293b !important;
          font-weight: 400 !important;
          border-bottom: 1px solid #e5e5e5 !important;
        }

        .wf-table-scroll tbody tr.selected-row:hover {
          background: linear-gradient(90deg, #eeeeee 0%, #f5f5f5 100%) !important;
        }

        /* ── Premium Tabs Styles (Matching WorkflowUser) ── */
        .wf-tab-bar {
          display: flex;
          align-items: stretch;
          gap: 4px;
          border-bottom: 2px solid #e5e5e5;
          margin-bottom: 0;
          padding: 8px 0 0;
          position: relative;
          flex: 0 0 auto;
        }

        .wf-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: transparent;
          padding: 9px 16px 11px;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          cursor: pointer;
          border-radius: 0;
          transition: color 0.2s ease, background 0.2s ease;
          outline: none;
          white-space: nowrap;
        }

        .wf-tab-btn i {
          font-size: 14px;
          color: currentColor;
          transition: color 0.2s ease;
        }

        .wf-tab-btn:hover {
          color: #0f172a;
          background: #f5f5f5;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff;
          font-weight: 500;
          background: #171717;
        }

        .wf-tab-btn.active i {
          color: #ffffff;
        }

        .wf-tab-btn::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #171717;
          border-radius: 0;
          transform: scaleX(0);
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0);
        }

        .wf-tab-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          height: 20px;
          padding: 0 6px;
          border-radius: 0;
          font-size: 12px;
          font-weight: 500;
          background: #f1f5f9;
          color: #64748b;
          border: 1px solid #e2e8f0;
          transition: all 0.2s ease;
          line-height: 1;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff;
          color: #1e293b;
          border-color: #ffffff;
        }

        .wf-tab-btn.tab-locked .wf-tab-badge {
          background: rgba(245,158,11,0.1);
          color: #b45309;
          border-color: rgba(245,158,11,0.2);
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        /* ── Selected Log Card Styles ─────────────────────── */
        .wf-assign-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 20px 24px;
          background: linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%);
          border: 1px solid #d4d4d4;
          border-radius: 14px;
          margin: 16px 0;
          flex-wrap: wrap;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-assign-actions {
          display: flex;
          gap: 8px;
          align-items: center;
          flex-wrap: wrap;
        }

        .wf-assign-actions .btn-action-search {
          height: auto !important;
          min-height: 32px !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }

        .wf-assign-actions .btn-danger-search {
          padding: 7px 12px !important;
          min-width: 32px !important;
        }

        .wf-assign-info {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wf-assign-avatar {
          width: 44px;
          height: 44px;
          border-radius: 0;
          background: #171717;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          flex-shrink: 0;
        }

        .wf-assign-meta strong {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin-bottom: 3px;
        }

        .wf-assign-meta span {
          font-size: 12px;
          color: #64748b;
          font-weight: 400;
        }

        .wf-table-scroll td,
        .wf-table-scroll tbody td {
          padding: 13px 16px !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: middle !important;
          transition: color 0.15s ease !important;
          background: transparent !important;
        }

        .wf-table-scroll tbody tr:last-child td {
          border-bottom: none !important;
        }

        /* Buttons inside the table (Location / Browser details) */
        .btn-view-action {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          color: #1e293b !important;
          padding: 7px 14px !important;
          min-height: 32px !important;
          height: auto !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          text-transform: none !important;
          letter-spacing: normal !important;
          line-height: 1 !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .btn-view-action i {
          font-size: 14px !important;
        }

        .btn-view-action:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
        }

        .btn-view-action:active {
          transform: translateY(0px) !important;
        }

        /* Loading progress bar and skeleton cells styles */
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        .wf-loading-bar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #171717, #737373, #171717);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 6px;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }

        .skeleton-row td {
          padding: 14px 16px !important;
        }

        /* Enhanced empty state */
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          text-align: center;
          gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-roles-empty-state {
          min-height: 250px;
          width: 100%;
        }

        .wf-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(124,58,237,0.06) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          color: #2563eb;
          margin-bottom: 4px;
        }

        .wf-empty-title {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin: 0;
          width: 100%;
          text-align: center;
        }

        .wf-empty-desc {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          margin: 0 auto;
          line-height: 1.6;
          text-align: center;
          width: 100%;
        }
      `}</style>

      <div className="col-md-12 ml-container">

        {/* Main Card */}
        <div className="card mb-4 shadow-none wf-main-card">
          <div className="wf-card-header-bar">
            {isLoading && <div className="wf-loading-bar" />}
            <div className="wf-header-left">
              <PageSizeOptions
                pageSize={pageSize}
                onChange={handlePageSizeChanged}
              />
              <span className="wf-stats-chip">
                <i className="fa fa-server" aria-hidden="true" />
                {rowsCount} Total Logs
              </span>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#collapseExample"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                disabled={isLoading}
                title="Reload logs"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>

          <div className="px-3">
            <div className="collapse" id="collapseExample">
              <div className="search-panel-collapse">

                {/* Panel Header */}
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Monitoring Logs
                  </span>
                </div>

                {/* Filter Fields */}
                <div className="sp-body">
                  <div className="row">

                    {/* User ID */}
                    <div className="col-md-3 form-group mb-3">
                      <label htmlFor="userId" className="wf-control-label">
                        User ID
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="userId"
                          id="userId"
                          className="form-control wf-input"
                          placeholder="e.g. 1045"
                          value={userId}
                          onChange={({ currentTarget }) => setUserId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter(pageSize, 1)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* User Name */}
                    <div className="col-md-3 form-group mb-3">
                      <label htmlFor="userName" className="wf-control-label">
                        User Name
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="userName"
                          id="userName"
                          className="form-control wf-input"
                          placeholder="Search user name..."
                          value={userName}
                          onChange={({ currentTarget }) => setUserName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter(pageSize, 1)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* IP Address */}
                    <div className="col-md-3 form-group mb-3">
                      <label htmlFor="ipAddress" className="wf-control-label">
                        IP Address
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="ipAddress"
                          id="ipAddress"
                          className="form-control wf-input"
                          placeholder="e.g. 192.168.1.1"
                          value={ipAddress}
                          onChange={({ currentTarget }) => setIpAddress(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter(pageSize, 1)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* Country */}
                    <div className="col-md-3 form-group mb-3">
                      <label htmlFor="country" className="wf-control-label">
                        Country
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="country"
                          id="country"
                          className="form-control wf-input"
                          placeholder="e.g. United States"
                          value={country}
                          onChange={({ currentTarget }) => setCountry(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter(pageSize, 1)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* Action Footer */}
                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    data-toggle="collapse"
                    data-target="#collapseExample"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button
                    className="btn-action-search"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={() => handleFilter(pageSize, 1)}
                    disabled={(isLoading && dataType === "filter") || (!userId.trim() && !userName.trim() && !ipAddress.trim() && !country.trim())}
                  >
                    {isLoading && dataType === "filter" ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                      </>
                    )}
                  </button>
                </div>

              </div>
            </div>
          </div>

          {/* Render Location Details Inline */}
          {selectedLogId > 0 && selectedLogObj && (
            <React.Fragment>
              {(() => {
                // Pre-define inline render methods
                window.renderLocationDetailsInline = () => {
                  let locationData = {};
                  try {
                    locationData = JSON.parse(selectedLogObj.locationDetails || "{}");
                  } catch (error) {
                    console.error("Error parsing locationDetails:", error);
                  }
                  return (
                    <div className="wf-inline-details card border" style={{ borderRadius: "14px", overflow: "hidden", borderColor: "#e2e8f0", boxShadow: "none" }}>
                      <div className="card-header border-bottom bg-white py-3 px-4" style={{ borderColor: "#f1f5f9" }}>
                        <h5 className="mb-0 text-dark" style={{ fontSize: "14px", fontWeight: 500, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', display: "flex", alignItems: "center", gap: "10px", color: "#1e293b" }}>
                          Location Coordinates &amp; Network Information
                        </h5>
                      </div>
                      <div className="card-body p-4">
                        <div className="row">
                          {[
                            { label: "Organization/ISP", val: locationData.org },
                            { label: "IP Address", val: locationData.ip },
                            { label: "City", val: locationData.city },
                            { label: "Region", val: locationData.region },
                            { label: "Postal Code", val: locationData.postal },
                            { label: "Coordinates", val: locationData.loc },
                            { label: "Timezone", val: locationData.timezone },
                            { label: "Country", val: locationData.country }
                          ].map((item, index) => (
                            <div key={index} className="col-md-6 mb-3">
                              <div style={{
                                padding: "14px 18px",
                                background: "#f8fafc",
                                border: "1px solid #e2e8f0",
                                borderRadius: "10px",
                                height: "100%"
                              }}>
                                <span style={{ fontSize: "12px", fontWeight: 600, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: "3px" }}>
                                  {item.label}
                                </span>
                                <span style={{ fontSize: "14px", color: "#1e293b", fontWeight: 400, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', display: "block" }}>
                                  {item.val || "N/A"}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                };

                window.renderBrowserDetailsInline = () => {
                  let browserData = {};
                  try {
                    browserData = JSON.parse(selectedLogObj.browserDetails || "{}");
                  } catch (error) {
                    console.error("Error parsing browserDetails:", error);
                  }
                  return (
                    <div className="wf-inline-details card border" style={{ borderRadius: "14px", overflow: "hidden", borderColor: "#e2e8f0", boxShadow: "none" }}>
                      <div className="card-header border-bottom bg-white py-3 px-4" style={{ borderColor: "#f1f5f9" }}>
                        <h5 className="mb-0 text-dark" style={{ fontSize: "14px", fontWeight: 500, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', display: "flex", alignItems: "center", gap: "10px", color: "#1e293b" }}>
                          Browser Capabilities &amp; System Properties
                        </h5>
                      </div>
                      <div className="card-body p-4">
                        <div className="row">
                          {Object.keys(browserData).length > 0 ? (
                            Object.entries(browserData).map(([key, val]) => (
                              <div key={key} className="col-md-6 mb-3">
                                <div style={{
                                  padding: "14px 18px",
                                  background: "#f8fafc",
                                  border: "1px solid #e2e8f0",
                                  borderRadius: "10px",
                                  height: "100%"
                                }}>
                                  <span style={{ fontSize: "12px", fontWeight: 600, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: "#64748b", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: "3px" }}>
                                    {key}
                                  </span>
                                  <span style={{ fontSize: "14px", color: "#1e293b", fontWeight: 400, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', display: "block" }}>
                                    {(val === null || val === undefined || String(val).toLowerCase() === "null" || String(val).toLowerCase() === "undefined" || String(val).trim() === "") ? "NA" : String(val)}
                                  </span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="col-12 text-center text-muted py-4" style={{ fontSize: "14px", fontWeight: 400, fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
                              No details available
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                };
                return null;
              })()}
            </React.Fragment>
          )}

          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">

            {/* Custom Tab Bar */}
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => handleTabSelect("home")}
              >
                <i className="fa fa-list-alt" />
                Audit Logs
                <span className="wf-tab-badge">{logs.length > 0 ? rowsCount : "—"}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "location" ? " active" : ""}`}
                onClick={() => handleTabSelect("location")}
              >
                <i className="fa fa-globe" />
                Location
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "browser" ? " active" : ""}`}
                onClick={() => handleTabSelect("browser")}
              >
                <i className="fa fa-desktop" />
                Browser
              </button>
            </div>

            {/* Tab Panels */}
            {selectedKey === "home" && (
              <div className="wf-tab-panel">

                {/* Selected log context card */}
                {selectedLogId > 0 && selectedLogObj && (
                  <div className="wf-assign-card" style={{ marginTop: 8, marginBottom: 14 }}>
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedLogObj.userName || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong>{selectedLogObj.userName} (ID: #{selectedLogObj.userid})</strong>
                        <span>
                          IP: {selectedLogObj.ipAddress}
                          &nbsp;&bull;&nbsp;
                          Country: {selectedLogObj.country || "Unknown"}
                          &nbsp;&bull;&nbsp;
                          Log ID: #{selectedLogObj.id}
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("location")}
                      >
                        <i className="fa fa-globe" /> Location Details
                      </button>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("browser")}
                      >
                        <i className="fa fa-desktop" /> Browser Details
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}

                <div className="wf-table-scroll mt-2">
                  <LogsTable
                    data={logs}
                    isLoading={isLoading}
                    dataType={dataType}
                    handleFilterCancel={handleFilterCancel}
                    pageSize={pageSize}
                    selectedLogId={selectedLogId}
                    handleSelectLog={handleSelectLog}
                    handleTabSelect={handleTabSelect}
                    handleResetSelection={handleResetSelection}
                  />
                  <div className="mt-3">
                    <Pagination
                      currentPage={currentPage}
                      pageSize={pageSize}
                      itemsCount={rowsCount}
                      onPageChange={handlePageChange}
                      startIndex={startIndex}
                      endIndex={endIndex}
                    />
                  </div>
                </div>

              </div>
            )}

            {selectedKey === "location" && (
              <div className="wf-tab-panel pt-2">
                {selectedLogId > 0 && selectedLogObj && (
                  <div className="wf-assign-card" style={{ marginTop: 8, marginBottom: 14 }}>
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedLogObj.userName || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong>{selectedLogObj.userName} (ID: #{selectedLogObj.userid})</strong>
                        <span>
                          IP: {selectedLogObj.ipAddress}
                          &nbsp;&bull;&nbsp;
                          Country: {selectedLogObj.country || "Unknown"}
                          &nbsp;&bull;&nbsp;
                          Log ID: #{selectedLogObj.id}
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("home")}
                      >
                        <i className="fa fa-arrow-left" /> Back to Logs
                      </button>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("browser")}
                      >
                        <i className="fa fa-desktop" /> Browser Details
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={() => {
                          handleResetSelection();
                          handleTabSelect("home");
                        }}
                        title="Clear selection"
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}
                {selectedLogId > 0 && window.renderLocationDetailsInline ? (
                  window.renderLocationDetailsInline()
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-globe" />
                    </div>
                    <p className="wf-empty-title">No Log Selected</p>
                    <p className="wf-empty-desc">
                      Select a log record from the table to view its location details.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Logs
                    </button>
                  </div>
                )}
              </div>
            )}

            {selectedKey === "browser" && (
              <div className="wf-tab-panel pt-2">
                {selectedLogId > 0 && selectedLogObj && (
                  <div className="wf-assign-card" style={{ marginTop: 8, marginBottom: 14 }}>
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedLogObj.userName || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong>{selectedLogObj.userName} (ID: #{selectedLogObj.userid})</strong>
                        <span>
                          IP: {selectedLogObj.ipAddress}
                          &nbsp;&bull;&nbsp;
                          Country: {selectedLogObj.country || "Unknown"}
                          &nbsp;&bull;&nbsp;
                          Log ID: #{selectedLogObj.id}
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("home")}
                      >
                        <i className="fa fa-arrow-left" /> Back to Logs
                      </button>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("location")}
                      >
                        <i className="fa fa-globe" /> Location Details
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={() => {
                          handleResetSelection();
                          handleTabSelect("home");
                        }}
                        title="Clear selection"
                      >
                        <i className="fa fa-times" />
                      </button>
                    </div>
                  </div>
                )}
                {selectedLogId > 0 && window.renderBrowserDetailsInline ? (
                  window.renderBrowserDetailsInline()
                ) : (
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-desktop" />
                    </div>
                    <p className="wf-empty-title">No Log Selected</p>
                    <p className="wf-empty-desc">
                      Select a log record from the table to view its browser details.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Logs
                    </button>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MonitoringLogs;
